module.exports = __webpack_public_path__ + "static/img/environment_02.9dc4c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/environment_02.png
// module id = LIHq
// module chunks = 34